import axios from '@/axios';
import router from '@/router';
import {dev} from '@/api/url';

// サーバーURL
const baseUrl = dev; // エンドポイント
const headers = {}
headers['Content-type'] = 'application/json'

const config = { //axiosの基本設定を定義
  timeout: 30000,//要請がtimeoutまでの時間,30秒
  method: null, //要請方法を指定
  emulateJSON: true,//JSONではなくURLの形式で送信する
  url: '',//要請されるURLを設定
  headers, //要請に使うヘーダ設定(以前設定したheaders)
  data: null, //データの初期値をnullで設定
  // withCredentials: true,
};

export default {
  // 画面一覧を取得するメソッド
  getTaskList: (authUserId, sessionKey, staffName) => {
    // エンドポイント設定
    config.url = baseUrl + "/api/screen/listGet"
    config.method = "post"
    config.data = {
      authInfo: {
        authUserId: authUserId,
        sessionKey: sessionKey,
        staffName: staffName,
      }
    };  // POSTリクエストで送るデータ設定

    return axios.request(config)
      .then(res => {
        return res;  // サーバーからの応答データを返す
      })
      .catch(err => {
        let ErrMsg = '';
        console.log("IN ERROR", err.response.status)

        // ネットワークエラーの場合
        if (err.code === 'ERR_NETWORK') {
          ErrMsg = err.message; // ネットワークエラー発生時
        } else if (err.response) {
          // サーバーからエラーレスポンスが返された場合
          if (err.response.status === 401) {
            console.log("IN 401", err.response.status)
            ErrMsg = err.response.data.message || '認証エラー発生';
            router.push('/login'); // ログインページにリダイレクト
          } else if (err.response.status === 404) {
            ErrMsg = err.response.data.message || '画面が見つかりません';
          } else {
            ErrMsg = err.response.data.message || 'その他のエラーメッセージ';
          }
        } else {
          // その他のエラー
          ErrMsg = err.message || '予期しないエラー';
        }

        return ErrMsg; // エラーメッセージを返す
      });
  },

  getScreenData: (screenId, authUserId, sessionKey) => {
    // エンドポイント設定
    config.url = baseUrl + "/api/screen/screenGet"
    config.method = "post"
    config.data = {
      screenId,
      authInfo: {
        authUserId: authUserId,
        sessionKey: sessionKey,
      }
    };  // POSTリクエストで送るデータ設定

    return axios.request(config)
      .then(res => {
        return res;  // サーバーからの応答データを返す
      })
      .catch(err => {
        let ErrMsg = '';

        // ネットワークエラーの場合
        if (err.code === 'ERR_NETWORK') {
          ErrMsg = err.message; // ネットワークエラー発生時
        } else if (err.response) {
          // サーバーからエラーレスポンスが返された場合
          if (err.response.status === 401) {
            ErrMsg = err.response.data.message || '認証エラー発生';
            router.push('/login'); // ログインページにリダイレクト
          } else if (err.response.status === 404) {
            ErrMsg = err.response.data.message || '画面が見つかりません';
          } else {
            ErrMsg = err.response.data.message || 'その他のエラーメッセージ';
          }
        } else {
          // その他のエラー
          ErrMsg = err.message || '予期しないエラー';
        }

        return ErrMsg; // エラーメッセージを返す
      });
  },
};
